import React, { useCallback, useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode.react';
import moment from 'moment';

import { wpinDeAPI } from '../../api/commonAPI';
import { TYPE } from '../../constant';
import { worksheetEmailSendAPI } from '../../api/globalAPI';
import WorksheetEmailPopup from './WorksheetEmailPopup';
import { useLoading } from '../../hooks';

function WorksheetHeader({ urlParams, lrnInfo, stgCd }) {

  const { setLoading, clearLoading } = useLoading();

  const [url, setUrl] = useState('');
  const [popup, setPopup] = useState(false);
  const isGuest = useRef(false);
  const email = useRef('')

  useEffect(() => {
    if (!lrnInfo) return;
    emailWpinDeAPI();
  }, [lrnInfo])

  useEffect(() => {
    console.log("##### urlParams: ", urlParams.current);
    const { langCd = 'KO', lrnMbrId = '', name = '', qstCds = '', regDate = '', memberType = '', memberemail = ''} = urlParams.current;
    setUrl(`?name=${name}&langCd=${langCd}&lrnMbrId=${lrnMbrId}&qstCds=${qstCds}&regdate=${regDate}&memberemail=${memberemail}`);

    // qr진입이 아닌 앱에서 진입 시 받은 member 정보로 guest 판별
    if (memberType && memberType === TYPE.GB_USER_TYPE.GUEST) {
      isGuest.current = true;
    } else {
      email.current = memberemail
    }
  }, [urlParams]);

  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') {
      console.log(`${process.env.REACT_APP_FRONT_WEB_URL}/worksheet?${encodeURIComponent(url + `&type=qrcode`)}`);
    }
    
  }, [url])

  // 이메일 복구화
  const emailWpinDeAPI = useCallback(async() => {
    try {
      const resp = await wpinDeAPI({
        type: 'E',
        str: lrnInfo.emailAdrs
      })
      if (!resp) throw Error(resp);

      const id = resp.split('@');
      // 이메일 복구화 후 lrn ID가 같으면 guest
      isGuest.current = id[0] === lrnInfo.modUser;
      
    } catch (error) {
      console.log("##### emailWpinDeAPI error: ", error);
    }
  }, [lrnInfo]);

  // 이메일 발송
  const worksheetEmailSendAPICall = useCallback(async (type, emailValue) => {
    const { lrnMbrId = '', langCd = 'KO' } = urlParams.current;
    if (!lrnMbrId) return;

    try {
      setLoading({ isShowSpinner: true, spinnerType: '1' });
      const resp = await worksheetEmailSendAPI({
        type,
        lrnMbrId,
        url: `${process.env.REACT_APP_FRONT_WEB_URL}/worksheet?${encodeURIComponent(url + `&type=email`)}`,
        rcvMail: type === '2' ? emailValue : '',
        stgCd, 
        langCd,
      });

      if (resp?.code === 'S000000') {
        setPopup(type === '2' ? false : true);
        clearLoading();
      }
    } catch (error) {
      console.log("##### worksheetEmailSendAPICall error: ", error);
    } finally {

      if (type === '2') {
        isGuest.current = false;
        email.current = emailValue;
        setPopup(true);
        isGuest.current = true;
      }

      
    }

  }, [isGuest, url, urlParams]);

  const handleEmailSend = useCallback(async () => {
    const type = isGuest.current ? '2' : '1';
    
    if (isGuest.current) {
      setPopup(true);
    } else {
      worksheetEmailSendAPICall(type);
    }
   
  }, [isGuest, url, urlParams]);


  const handlePrint = useCallback(() => {
    window.print();
  }, []);

  const handleEmailSendPopup = useCallback(() => {
    setPopup(!popup);
  }, [popup]);

  return (
    <React.Fragment>
      <div className="header">
        <div className="header_wrap">
          <div className="btn_area">
            {
              (urlParams.current?.type !== 'email' && urlParams.current?.type !== 'qrcode') && (
                <button
                  type="button"
                  className="btn_email"
                  onClick={handleEmailSend}
                >
                  <span className="blind">메일 보내기</span>
                </button>
              )
            }
            <button
              type="button"
              className="btn_print"
              onClick={handlePrint}
            >
              <span className="blind">프린트 출력</span>
            </button>
          </div>
            <div className="qr_area">
              <QRCode
                className="work_qr"
                size={100}
                value={`${process.env.REACT_APP_FRONT_WEB_URL}/worksheet?${encodeURIComponent(url + `&type=qrcode`)}`}
              />
              <p className="qr_txt">check the answer</p>
            </div>
          <div className="cha_area">
            <div className="tit_box">
              <h1><img src="./static/images/common/logo_mathpid_wht.svg" alt="Mathpid" /></h1>
              <h2>Worksheet</h2>
            </div>
            <div className="sn_box">
              <span className="blue">Student</span>
              <span className="black">
                {urlParams.current.name ? urlParams.current.name : lrnInfo?.mbrNm}
              </span>
              <span className="blue">Date</span>
              <span className="black">
                {urlParams.current?.regdate ? urlParams.current.regdate : moment(new Date()).format('YY/MM/DD')}
              </span>
            </div>
          </div>
        </div>
      </div>
      {popup && (
        <WorksheetEmailPopup 
          isGuest={isGuest} 
          email={email}
          worksheetEmailSendAPICall={worksheetEmailSendAPICall}
          handleEmailSendPopup={handleEmailSendPopup} 
        />
      )}
      
    </React.Fragment>
  );
}

export default WorksheetHeader;